module.exports = __webpack_public_path__ + "static/media/logo.c55bb672.png";